import SettingsSidebar from './settings';
import AccountSidebar from './account';

export { SettingsSidebar, AccountSidebar };
